// tslint:disable-next-line: max-line-length
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '__services';
import { cloneDeep } from 'lodash';
import { CancelActions } from '~/app/containers/dashboard/intermodal/constants/intermodal.const';
import {
    RoleService,
    SwalService,
} from '~/app/core/services';

@Component({
  selector: 'app-cancelled-action',
  templateUrl: './cancelled-action.component.html',
  styleUrls: ['./cancelled-action.component.scss'],
})
export class CancelledActionComponent implements OnInit {
  @Input() isLocked: boolean;

  cancelActions = cloneDeep(CancelActions);
  form: FormGroup;
  deletePermission: boolean;

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private roleService: RoleService,
    private translationService: TranslateService,
    private swalService: SwalService
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.deletePermission = this.roleService.hasDelete(
      this.activatedRoute.snapshot
    );
    this.cancelActions.forEach((item) => {
      if (item.value === 2 && !this.deletePermission) {
        item.access = false;
      } else {
        item.access = true;
      }
    });
  }

  createForm(): void {
    this.form = this.fb.group({
      cancelled_action: [3, [Validators.required]],
      cancelled_reason: ['', [Validators.required]],
    });
  }

  onChangeCancelAction(value): void {
    if (this.form.get('cancelled_action').value === value) {
      this.form.patchValue({ cancelled_action: null });
    } else {
      this.form.patchValue({ cancelled_action: value });
    }
  }

  async askPopup(): Promise<boolean> {
    if (this.form.get('cancelled_action').value === 2) {
      const message = this.translationService.translate(
        'Doing action "Cancel & Stop Cargo" will be permanent and will removed the cargo. Are you sure you want to proceed?'
      )
      const result = await this.swalService.yesNoSwal(message);
      return result.value;
    }
    return true;
  }
}
